var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup992(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#DBFFDF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5052_187765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.332 39.9998C23.8654 39.9998 22.6787 41.1998 22.6787 42.6665C22.6787 44.1332 23.8654 45.3332 25.332 45.3332C26.7987 45.3332 27.9987 44.1332 27.9987 42.6665C27.9987 41.1998 26.7987 39.9998 25.332 39.9998ZM17.332 19.9998C17.332 20.7332 17.932 21.3332 18.6654 21.3332H19.9987L24.7987 31.4532L22.9987 34.7065C22.0254 36.4932 23.3054 38.6665 25.332 38.6665H39.9987C40.732 38.6665 41.332 38.0665 41.332 37.3332C41.332 36.5998 40.732 35.9998 39.9987 35.9998H25.332L26.7987 33.3332H36.732C37.732 33.3332 38.612 32.7865 39.0654 31.9598L43.8387 23.3065C44.332 22.4265 43.692 21.3332 42.6787 21.3332H22.9454L22.052 19.4265C21.8387 18.9598 21.3587 18.6665 20.852 18.6665H18.6654C17.932 18.6665 17.332 19.2665 17.332 19.9998ZM38.6654 39.9998C37.1987 39.9998 36.012 41.1998 36.012 42.6665C36.012 44.1332 37.1987 45.3332 38.6654 45.3332C40.132 45.3332 41.332 44.1332 41.332 42.6665C41.332 41.1998 40.132 39.9998 38.6654 39.9998Z",
    fill: "#2B8C34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5052_187765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup992);
export default __webpack_public_path__ + "static/media/Group 992.5381b5b9e38fed524e71794ef815b9c3.svg";
export { ForwardRef as ReactComponent };